import React from 'react';
import CheckIcon from '@material-ui/icons/Check';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import ApproveSupplierPoRecord from '../../supplierPOApprove';
import useStyles from './buttonStyles';

const ApproveButton = (props) => {
  const classes = useStyles();
  const [open, setOpen] = React.useState(false);
  const handleClose = () => {
    setOpen(false);
  };
  const handleClickRecieved = () => {
    setOpen(true);
  };
  return (
    <React.Fragment>
      <Button
        disableElevation
        disableFocusRipple
        disableRipple
        className={classes.button}
        onClick={handleClickRecieved}
      >
        <div
          className={classes.logo}
          style={{ width: props?.status === 13 && '8.3rem' }}
        >
          <CheckIcon fontSize='small' className={classes.logoHeight} /> &nbsp;
          <Typography variant='body1'>Approve</Typography>
        </div>
      </Button>
      <ApproveSupplierPoRecord
        open={open}
        handleClose={handleClose}
        {...props}
      />
    </React.Fragment>
  );
};

export default ApproveButton;
